import { render } from "./IndustryCard.vue?vue&type=template&id=ff335cc6"
import script from "./IndustryCard.vue?vue&type=script&lang=js"
export * from "./IndustryCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__